import { jsx as _jsx } from "react/jsx-runtime";
import s from './button.module.scss';
const buttonVariant = {
    primary: s.primaryVariant,
    action: s.actionVariant,
    border: s.borderVariant
};
export const Button = ({ variant = 'primary', disabled = false, className, children, ...restProps }) => (_jsx("button", { className: `${s.btn} ${buttonVariant[variant]} ${disabled ? s.disabled : ''} ${className || ''}`, ...restProps, children: children }));
